/*
 * @Description: Description
 * @Author: Xiaohua Zhu
 * @Date: 2021-12-02 19:01:45
 * @LastEditors: Xiaohua Zhu
 * @LastEditTime: 2022-06-15 10:37:12
 */
// 侧板放置的位置 first表示柜体x0-x1,z0-z1,x1z0-x1z1的第一块,last则表示最后一块
export var SidePlateSequence;
(function (SidePlateSequence) {
    SidePlateSequence["First"] = "first";
    SidePlateSequence["Last"] = "last";
    SidePlateSequence["Corner"] = "corner ";
})(SidePlateSequence || (SidePlateSequence = {}));
export var SidePlateLocation;
(function (SidePlateLocation) {
    SidePlateLocation["First"] = "first";
    SidePlateLocation["Last"] = "last";
    SidePlateLocation["Corner"] = "corner";
})(SidePlateLocation || (SidePlateLocation = {}));
// 侧板放置在顶柜还是底柜
export var SidePlatePosition;
(function (SidePlatePosition) {
    SidePlatePosition["Top"] = "top";
    SidePlatePosition["Bottom"] = "bottom";
})(SidePlatePosition || (SidePlatePosition = {}));
export var CornerCabinetDirection;
(function (CornerCabinetDirection) {
    CornerCabinetDirection["Right"] = "right";
    CornerCabinetDirection["Left"] = "left";
})(CornerCabinetDirection || (CornerCabinetDirection = {}));
// 柜子位置
export var LengthLocation;
(function (LengthLocation) {
    LengthLocation["Top"] = "top";
    LengthLocation["Bottom"] = "bottom";
})(LengthLocation || (LengthLocation = {}));
export var LengthType;
(function (LengthType) {
    LengthType["Length1"] = "length1";
    LengthType["Length2"] = "length2";
    LengthType["Length3"] = "length3";
    LengthType["Length4"] = "length4";
})(LengthType || (LengthType = {}));
export var BASICTYPE_ENUM;
(function (BASICTYPE_ENUM) {
    BASICTYPE_ENUM["top"] = "top";
    BASICTYPE_ENUM["bottom"] = "bottom";
})(BASICTYPE_ENUM || (BASICTYPE_ENUM = {}));
export var BASICLENGTHTYPE_ENUM;
(function (BASICLENGTHTYPE_ENUM) {
    BASICLENGTHTYPE_ENUM["length1"] = "length1";
    BASICLENGTHTYPE_ENUM["length2"] = "length2";
    BASICLENGTHTYPE_ENUM["length3"] = "length3";
    BASICLENGTHTYPE_ENUM["length4"] = "length4";
})(BASICLENGTHTYPE_ENUM || (BASICLENGTHTYPE_ENUM = {}));
export var CALLOUTLINE_TYPE;
(function (CALLOUTLINE_TYPE) {
    CALLOUTLINE_TYPE["Length"] = "length";
    CALLOUTLINE_TYPE["StartHeight"] = "startHeight";
    CALLOUTLINE_TYPE["EndHeight"] = "endHeight";
    CALLOUTLINE_TYPE["StartDepth"] = "startDepth";
    CALLOUTLINE_TYPE["EndDepth"] = "endDepth";
})(CALLOUTLINE_TYPE || (CALLOUTLINE_TYPE = {}));
export var CALLOUTLINE_TITLE;
(function (CALLOUTLINE_TITLE) {
    CALLOUTLINE_TITLE["L1"] = "L1";
    CALLOUTLINE_TITLE["L2"] = "L2";
    CALLOUTLINE_TITLE["L3"] = "L3";
})(CALLOUTLINE_TITLE || (CALLOUTLINE_TITLE = {}));
export var BASICRENDER_TYPE;
(function (BASICRENDER_TYPE) {
    BASICRENDER_TYPE["I"] = "I";
    BASICRENDER_TYPE["L"] = "L";
    BASICRENDER_TYPE["U"] = "U";
    BASICRENDER_TYPE["H"] = "H";
    BASICRENDER_TYPE["U_S"] = "U_S";
})(BASICRENDER_TYPE || (BASICRENDER_TYPE = {}));
export var AXES_TYPE;
(function (AXES_TYPE) {
    AXES_TYPE["font"] = "font";
    AXES_TYPE["back"] = "back";
})(AXES_TYPE || (AXES_TYPE = {}));
export var AXES_ENUM;
(function (AXES_ENUM) {
    AXES_ENUM["x"] = "x";
    AXES_ENUM["y"] = "y";
    AXES_ENUM["z"] = "z";
})(AXES_ENUM || (AXES_ENUM = {}));
export var SIDE_PLATE_TYPE;
(function (SIDE_PLATE_TYPE) {
    SIDE_PLATE_TYPE[SIDE_PLATE_TYPE["refrigerator"] = 1] = "refrigerator";
})(SIDE_PLATE_TYPE || (SIDE_PLATE_TYPE = {}));
// 柜体高度
export var CABINET_HEIGHT_TYPE;
(function (CABINET_HEIGHT_TYPE) {
    CABINET_HEIGHT_TYPE[CABINET_HEIGHT_TYPE["Seventy"] = 70] = "Seventy";
    CABINET_HEIGHT_TYPE[CABINET_HEIGHT_TYPE["Eighty"] = 80] = "Eighty";
})(CABINET_HEIGHT_TYPE || (CABINET_HEIGHT_TYPE = {}));
